// assets/mobile-master.js
class MobileMaster {
  constructor() {
    this.config = {};
    this.init();
  }
  
  init() {
    if (window.innerWidth >= 750) return;
    
    this.loadConfig();
    this.restructureHeader();
    this.replaceHeroImages();
    this.applyLayoutPresets();
    this.optimizeMobileUX();
  }
  
  loadConfig() {
    const configEl = document.getElementById('mobile-config');
    if (configEl) {
      this.config = JSON.parse(configEl.dataset.config);
    }
  }
  
  restructureHeader() {
    const headerInner = document.querySelector('.header__inner');
    const headerIcons = document.querySelector('.header__icons');
    
    if (!headerInner || !headerIcons) return;
    
    // Create discount button
    const discountBtn = document.createElement('a');
    discountBtn.className = 'mobile-discount-btn';
    discountBtn.href = this.getDiscountLink();
    discountBtn.textContent = 'Get 10% Discount';
    discountBtn.style.cssText = 'display: none !important;';
    
    // Insert button before icons
    headerIcons.parentNode.insertBefore(discountBtn, headerIcons);
    
    // Reorder icons: search, cart, menu
    this.reorderHeaderIcons(headerIcons);
    
    // Show elements after restructuring
    setTimeout(() => {
      discountBtn.style.display = 'inline-block !important';
    }, 100);
  }
  
  getDiscountLink() {
    // You can make this configurable via settings
    return '/discount/GET10?redirect=/';
  }
  
  reorderHeaderIcons(iconsContainer) {
    const search = iconsContainer.querySelector('.header__icon--search');
    const cart = iconsContainer.querySelector('.header__icon--cart');
    const menu = iconsContainer.querySelector('.header__icon--menu');
    const account = iconsContainer.querySelector('.header__icon--account');
    
    if (!search || !cart || !menu) return;
    
    // Clear and reappend in desired order
    iconsContainer.innerHTML = '';
    
    if (search) iconsContainer.appendChild(search);
    if (cart) iconsContainer.appendChild(cart);
    if (account) iconsContainer.appendChild(account);
    if (menu) iconsContainer.appendChild(menu);
  }
  
  replaceHeroImages() {
    // Homepage hero replacement
    if (this.isHomepage() && this.config.homeHero) {
      this.replaceHeroBackground(this.config.homeHero);
    }
    
    // Collection page hero replacement  
    if (this.isCollectionPage() && this.config.collectionHero) {
      this.replaceHeroBackground(this.config.collectionHero);
    }
  }
  
  replaceHeroBackground(imageUrl) {
    const heroMedia = document.querySelector('.hero__media');
    if (heroMedia) {
      heroMedia.classList.add('mobile-hero-replaced');
      heroMedia.style.backgroundImage = `url('${imageUrl}')`;
    }
  }
  
  applyLayoutPresets() {
    // Apply product grid layout
    if (this.config.productLayout) {
      document.querySelectorAll('.product-grid, .grid').forEach(grid => {
        grid.classList.add(`mobile-layout-${this.config.productLayout}`);
      });
    }
    
    // Apply collection layout
    if (this.config.collectionLayout) {
      document.querySelectorAll('.collection-grid, .collection-list').forEach(grid => {
        grid.classList.add(`mobile-layout-${this.config.collectionLayout}`);
      });
    }
    
    // Auto-apply single column to all multi-column grids
    document.querySelectorAll('.grid--2-col, .grid--3-col, .grid--4-col').forEach(grid => {
      if (!grid.classList.contains('mobile-layout-single-column')) {
        grid.classList.add('mobile-layout-single-column');
      }
    });
  }
  
  optimizeMobileUX() {
    // Add mobile-specific UX enhancements
    this.optimizeProductPage();
    this.optimizeCartPage();
    this.enhanceTouchInteractions();
  }
  
  optimizeProductPage() {
    if (!this.isProductPage()) return;
    
    const buyBtn = document.querySelector('.product-form__submit');
    if (buyBtn) {
      buyBtn.style.position = 'sticky';
      buyBtn.style.bottom = '0';
      buyBtn.style.zIndex = '100';
    }
  }
  
  optimizeCartPage() {
    if (!this.isCartPage()) return;
    
    const cartFooter = document.querySelector('.cart__footer');
    if (cartFooter) {
      cartFooter.style.position = 'sticky';
      cartFooter.style.bottom = '0';
      cartFooter.style.background = 'white';
      cartFooter.style.padding = '15px';
      cartFooter.style.boxShadow = '0 -2px 10px rgba(0,0,0,0.1)';
    }
  }
  
  enhanceTouchInteractions() {
    // Increase tap targets for mobile
    document.querySelectorAll('a, button').forEach(el => {
      if (el.offsetHeight < 44 || el.offsetWidth < 44) {
        el.style.minHeight = '44px';
        el.style.minWidth = '44px';
        el.style.display = 'flex';
        el.style.alignItems = 'center';
        el.style.justifyContent = 'center';
      }
    });
  }
  
  isHomepage() {
    return document.body.classList.contains('template-index');
  }
  
  isProductPage() {
    return document.body.classList.contains('template-product');
  }
  
  isCollectionPage() {
    return document.body.classList.contains('template-collection');
  }
  
  isCartPage() {
    return document.body.classList.contains('template-cart');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MobileMaster());
} else {
  new MobileMaster();
}